import React, { useState, useEffect } from "react";
import CustomTable from "../../../core/custom-table";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import { Box, IconButton } from "@mui/material";
import CustomButtonComponent from "../../../core/custom-button";
import { HeaderConfig, SapClaimsHeaderConfig } from "./config";
import ClaimsFilters from "../../oem/claims/claims-filters";
import { PAGE_LIMIT } from "../../../utils";
import SiFileUpload from "../../../core/file-uploader";

const SapClaims = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
  });

  const downloadReports = () => {
    const limit = data.totalResults;
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.SAP_CLAIMS}`,
      null,
      { download: "TRUE", limit: limit },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Claims.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };

  const loadData = (filters) => {
    const payload = { ...filters };
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.SAP_CLAIMS}`,
      null,
      payload
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setData(res);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div className=" view-detailed-ticket">
        <div>
          <p className="tab-name">Claims</p>
          <p className="section-name">Warranty Claims From SAP</p>
        </div>
      </div>
      <div>
        <div className="create-con">
          <p className="primary-text">Warranty Claims</p>
          <Box sx={{ display: "flex", gridGap: "20px" }}>
            <SiFileUpload
              fileTypes={[
                ".csv",
                ".xls",
                ".xlsx",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel",
              ]}
              title="Upload Bulk Claims"
              url={`${HOSTNAME}${REST_URLS.SAP_CLAIMS}/bulk-upload`}
              callBack={() => {
                loadData({
                  page: 1,
                  sortBy: "-createdAt",
                  limit: PAGE_LIMIT,
                });
              }}
            />
            <CustomButtonComponent
              variant="contained"
              color="success"
              onClick={downloadReports}
            >
              Download Claims
            </CustomButtonComponent>
          </Box>
        </div>
        <div className="si-hide-mobile">
          <CustomTable
            header={SapClaimsHeaderConfig}
            data={data.results || []}
            pageCount={data.totalPages}
            filters={filters}
            onChange={(page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                page,
              });
            }}
            filterCom={<ClaimsFilters loadData={loadData} isSap={true} />}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};
export default SapClaims;
